// extracted by mini-css-extract-plugin
export var checkbox = "_7o-0";
export var circle = "_7o-3";
export var horizontalContainer = "_7o-7";
export var sm = "_7o-5";
export var switch0 = "_7o-2";
export var switchDisabled = "_7o-8";
export var switchEnabled = "_7o-1";
export var textSwitchContainer = "_7o-9";
export var textSwitchOption = "_7o-a";
export var textSwitchOptionSelected = "_7o-b";
export var verticalContainer = "_7o-6";
export var xs = "_7o-4";